<template>
  <div ref="sources">
    <template v-if="!storeState.gotSources">
      <v-dialog v-model="!storeState.gotSources" fullscreen full-width retain-focus>
        <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.8);">
          <v-row>
            <v-col cols="12" sm="12" class="text-center">
              <v-progress-circular
                indeterminate
                :size="100"
                :width="8"
                color="primary"
                class="justify-center align-center"
              >
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
    </template>
    <template v-else-if="!storeState.blocks.length === 0">
      <div class="nosource-container">
        <div class="nosource">
          <h4>
            <button @click="focusSource" class="btn-link"> Select</button> 
            a source or <button @click="storeState.addingSource = true" class="btn-link"> add a new one.</button>
          </h4>
        </div>
      </div>
    </template>
    <div v-else class="soup-search-container">
      <div class="search-underlay">
        <div v-html="underlay"></div>
      </div>
      <div class="search-text-container pl-3">
        <textarea placeholder="Search" ref="searchText" 
        v-model="searchTerm" rows="1" wrap="off" class="search-text mousetrap" spellcheck="false"></textarea>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <span v-on="on" class="conn-top-right">
              <v-btn icon @click="backToBlocks">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </span>
          </template>
          <span>Close</span>
        </v-tooltip>
      </div>
    </div>
    <div class="search-container">
      <div>
        <div ref="blocksContainer">
          <!-- 00c16f4eb23e4905abc3fcd0b8071fd7: Object
          code: "select 1"
          destination: Object
          email: "mike@seekwell.io"
          favorite: false
          source: Object
          uuid: "00c16f4eb23e4905abc3fcd0b8071fd7" -->
          <div 
          :data-uuid="row.uuid"
          :ref="'block_' + index"
          :id="'block_' + index"
          v-for="(row, index) in uniqueSources"
          :key="row.block_uuid"
          @mouseover="hoverRow(row, index, true)"
          @mouseleave="hoverRow(row, index, false)"
          :class="{
            'active': (index === storeState.searchIndex), 
            'row-hover': storeState.searchIndex < 0,
            'searchResultRows': true,
            }"
          >
            <div>
              <v-row>
                <v-col cols="12" sm="1" md="1" :data-uuid="row.uuid" class="">
                  <button class="soup-btn pad-btn" @click="favoriteSource(row)">
                    <v-icon class="blocks-icon">{{ row.favorite ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                  </button>
                </v-col>
                <v-col cols="12" sm="3" md="3" :data-uuid="row.uuid" class="">
                  <div class="row-title"> {{ row.name ? row.name : 'Untitled' }} </div>
                </v-col>
                <v-col cols="12" sm="3" md="3" :data-uuid="row.uuid" class="">
                  <div class="row-title"> {{ row.db_type }} </div>
                </v-col>
                <v-col cols="12" sm="4" md="4" :data-uuid="row.uuid" class="dense-col">
                  <div class="row-host">{{ row.username }} on {{ row.host }} </div>
                </v-col>
                <v-col cols="12" sm="1" md="1" class="nopad">
                  <div 
                  :class="{
                    'hide': (blockHoverIndex != index), 
                    'block-icons': true,
                  }">
                    <button class="soup-btn" @click="editSource(row)">
                       <v-icon>mdi-pencil</v-icon>
      
                    </button>
                    &nbsp;&nbsp;
                    <button class="soup-btn" @click="deleteSource(row)">
                      <v-icon class="blocks-icon">mdi-delete</v-icon>
                    </button>
                  </div>
                  <div 
                  :class="{
                    'hide': (blockHoverIndex === index), 
                    'row-last-run': true
                  }">
                    <v-avatar size="18" class="mr-1" :data-email="row.email">
                      <img :src="getUserPic(row.email)">
                    </v-avatar>
                  </div>
                  <!-- <div v-if="blockHoverIndex === index">
                    <button class="soup-btn" @click="deleteBlock(row)">
                      <v-icon class="blocks-icon">mdi-delete</v-icon>
                    </button>
                    <button class="soup-btn pad-btn" @click="runBlock(row)">
                      <v-icon class="blocks-icon">mdi-play</v-icon>
                    </button>
                  </div> -->
                </v-col>
              </v-row>
              <!-- <pre>{{ row }} </pre> -->
            </div>
          </div>
        </div>
      </div>  
    </div>
    <v-dialog :value="storeState.addingSource" v-model="storeState.addingSource" persistent retain-focus max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Edit Source</span>
          <v-spacer></v-spacer>
          <v-btn
              icon
            >
              <v-icon @click="cancelAddSource">mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text v-if="newSource.db_type === 'bigquery'">
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                :items="dbTypes"
                v-model="newSource.db_type"
                item-text="label"
                item-value="key"
                label="Flavor"
                required
                outlined
                disabled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field 
                  ref="newSourceName"
                  v-model="newSource.name"
                  autocomplete="off"
                  :rules="[sourceRules.required, sourceRules.portMin]"
                  label="Nickname" 
                  hint="This can be anything you want"
                  class="source-input"
                  required
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field 
                  name="host"
                  ref="newSourceApiKey"
                  v-model="newSource.apiKey" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="Service Account Information (paste in JSON)"
                  class="source-input"
                  required
                  outlined
                  >
                </v-text-field>
                <div>
                  <a class="tw-text-blue-500" href="https://doc.seekwell.io/d349db8b1599451e8f78f2a66ac10a77" target="_blank">
                    Click here
                  </a> 
                  for help creating service account credentials
                </div>
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-text v-else-if="newSource.db_type === 'airtable'">
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                :items="dbTypes"
                v-model="newSource.db_type"
                item-text="label"
                item-value="key"
                label="Flavor"
                required
                outlined
                disabled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field 
                  ref="newSourceName"
                  v-model="newSource.name"
                  autocomplete="off"
                  :rules="[sourceRules.required, sourceRules.portMin]"
                  label="Nickname" 
                  hint="This can be anything you want"
                  class="source-input"
                  required
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field 
                  name="host"
                  ref="newSourceApiKey"
                  v-model="newSource.apiKey" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="API Key"
                  class="source-input"
                  required
                  outlined
                  >
                </v-text-field>
                <div>
                  Visit 
                  <a class="tw-text-blue-500" href="https://airtable.com/account" target="_blank">your Airtable account</a> 
                  to get your key (look for the "API" section)
                </div>
              </v-col>
            </v-row>
        </v-card-text>
        <v-card-text v-else-if="newSource.db_type != 'snowflake'">
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                :items="dbTypes"
                v-model="newSource.db_type"
                item-text="label"
                item-value="key"
                label="Flavor"
                required
                outlined
                disabled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field 
                  v-model="newSource.name"
                  ref="newSourceName"
                  autocomplete="off"
                  :rules="[sourceRules.required, sourceRules.portMin]"
                  label="Nickname" 
                  hint="This can be anything you want"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <v-text-field 
                  name="host"
                  v-model="newSource.host" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="Host" 
                  hint="Full host name or IP address"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-text-field 
                  v-model="newSource.port" 
                  autocomplete="off"
                  :rules="[sourceRules.required, sourceRules.portMin]"
                  label="Port"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-username"
                  v-model="newSource.username" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="Username" 
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                <v-text-field 
                  name="search-password"
                  type="password"
                  v-model="newSource.password" 
                  autocomplete="new-password"
                  label="Password" 
                  hint="Leave it blank if you don't want to change the password"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field 
                  name="search-database"
                  ref="newDatabaseName"
                  v-model="newSource.database" 
                  autocomplete="new-password"
                  label="Database"
                  :rules="[sourceRules.required]"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-checkbox
                  v-model="newSource.ssl"
                  label="Use SSL"
                  class="source-input"
                ></v-checkbox>
                <v-checkbox
                  v-model="newSource.ssh"
                  label="Use SSH"
                  class="source-input"
                ></v-checkbox>
              </v-col>
              <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                <v-text-field 
                  name="sshHost"
                  v-model="newSource.sshHost" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="SSH Host" 
                  hint="e.g. e2c-123.amazonaws.com"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                <v-text-field 
                  name="sshUsername"
                  v-model="newSource.sshUsername" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="SSH Username" 
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-ssh-password"
                  type="password"
                  autocomplete="new-password"
                  v-model="newSource.sshPassword"
                  label="SSH Password" 
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col v-if="newSource.ssh" cols="12" sm="6" md="6">
                <v-text-field 
                  name="sshPort"
                  v-model="newSource.sshPort" 
                  autocomplete="off"
                  label="SSH Port (Optional)" 
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col v-if="newSource.ssh" cols="12" sm="12" md="12">
                <v-textarea 
                  name="sshPrivateKey"
                  v-model="newSource.sshPrivateKey" 
                  autocomplete="off"
                  label="Private Key (Optional)" 
                  class="source-input"
                  outlined
                  >
                </v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <p style="font-size: 16px;">You need to whitelist our IP addresses (35.193.207.79 and 35.239.74.213) for your connection to work.</p>
                <a 
                  href="https://intercom.help/seekwell/en/collections/2052529-connecting"
                  target="_blank"
                >
                  <strong style="font-size: 16px;">
                    Need help with this?
                  </strong>
                </a>
              </v-col>
            </v-row>
            
          </v-container>
        </v-card-text>
        <v-card-text v-else>
          <v-container>
            <v-row>
              <v-col cols="12" sm="4" md="4">
                <v-select
                :items="dbTypes"
                v-model="newSource.db_type"
                item-text="label"
                item-value="key"
                label="Flavor"
                required
                outlined
                disabled
                ></v-select>
              </v-col>
              <v-col cols="12" sm="8" md="8">
                <v-text-field 
                  v-model="newSource.name"
                  ref="newSourceName"
                  autocomplete="off"
                  :rules="[sourceRules.required, sourceRules.portMin]"
                  label="Nickname" 
                  hint="This can be anything you want"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <v-text-field 
                  name="host"
                  ref="newSourceAccountName"
                  v-model="newSource.accountName" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="Account Name" 
                  hint="Do not include region"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <v-select
                  :items="snowRegions"
                  v-model="newSource.region"
                  :rules="[sourceRules.required]"
                  label="Region"
                  class="source-input"
                  required
                  outlined
                  ></v-select>
              </v-col>
              
              <v-col cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-username"
                  v-model="newSource.username" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="Username" 
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <!-- <v-text-field :value="newSource.password" required password label="Password" ></v-text-field> -->
                <v-text-field 
                  name="search-password"
                  type="password"
                  v-model="newSource.password" 
                  autocomplete="new-password"
                  label="Password" 
                  hint="Leave blank if no password"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-warehouse"
                  v-model="newSource.warehouse" 
                  autocomplete="off"
                  :rules="[sourceRules.required]"
                  label="Warehouse" 
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-database"
                  ref="newDatabaseName"
                  v-model="newSource.database" 
                  autocomplete="new-password"
                  label="Database"
                  :rules="[sourceRules.required]"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-database"
                  v-model="newSource.schema" 
                  autocomplete="new-password"
                  label="Schema"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-database"
                  v-model="newSource.role" 
                  autocomplete="new-password"
                  label="Role"
                  hint="e.g. ADMIN"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field 
                  name="search-database"
                  v-model="newSource.authenticator" 
                  autocomplete="new-password"
                  label="Authenticator (optional)"
                  class="source-input"
                  outlined
                  >
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <div v-if="connectError">
          <v-row>
            <div class="error--text connect-error">
              {{connectError}}
            </div>
          </v-row>
        </div>
        
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <div class="tw-flex tw-justify-end tw-pr-4 tw-pb-4">
          &nbsp;&nbsp;<v-btn color="error" outlined text @click="cancelAddSource">Cancel</v-btn> 
        <v-spacer>&nbsp;&nbsp;</v-spacer>
          <v-btn  color="blue" outlined text @click="editSourcefields" :loading="savingSource">Save Changes</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import debounce from 'debounce';
import { store } from '../store.js';
import draggable from 'vuedraggable';
import _ from 'lodash';


export default {
  mounted() {
    window.bus.$on('focusEl', (details) => {
      setTimeout(() => {
        let ref = this.$refs[details.el]
        if (ref) ref.focus()
      }, 0);
    });
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      savingSource: false,
      whitelistError: false,
      dbTypes: [
        {key: 'mysql', label: 'MySQL', portHint: 'e.g. 3306'}, 
        {key: 'postgres',  label: 'Postgres', portHint: 'e.g. 5432'},
        {key: 'snowflake',  label: 'Snowflake'},
        {key: 'mssql',  label: 'MS SQL Server', portHint: 'e.g. 1433'},
        {key: 'redshift',  label: 'Redshift', portHint: 'e.g. 5439'},
        {key: 'airtable',  label: 'Airtable', portHint: 'na'},
        {key: 'bigquery',  label: 'BigQuery', portHint: 'na'},
      ],
      showPass: false,
      newSource: {
        name: '',
        db_type: 'mysql',
        host: '',
        port: '',
        ssl: false,
        username: '',
        password: '',
        database: '',
        metadata: false,
      },
      connectError: '',
      sourceRules: {
        required: value => !!value || 'Required.',
        portMin: v => v.length >= 2 || 'Min 2 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      snowRegions: [
        "us-west-1", "us-west-2", "us-east-1", "us-east-2.aws", "us-east-2.azure", "eu-west-1", "eu-central-1", "ca-central-1", 
        "ap-southeast-1", "ap-southeast-2", "east-us-2.azure", "us-gov-virginia.azure", 
        "west-europe.azure", "australia-east.azure"
      ],
      blockHoverIndex: -1,
      searchTerm: '', 
      searching: store.state.searching,
      favorites: false,
      scheduled: false,
      searchResults: [],
      saved: false,
      blockCategories: [
        {id: 0, name: 'All', f: function(self) {
          self.favorites = false
          self.scheduled = false
          self.saved = false
          }
        },
        {id: 1, name: 'Saved', f: function(self) {
          console.log('Saved...')
          self.favorites = false
          self.scheduled = false
          self.saved = true
          // this.$forceUpdate()
          }
        },
        {id: 2, name: 'Scheduled', f: function(self) {
          console.log('favorites...')
          self.favorites = false
          self.saved = false
          self.scheduled = true
          // this.$forceUpdate()
          }
        },
        {id: 3, name: 'Favorites', f: function(self) {
          console.log('favorites...')
          self.scheduled = false
          self.saved = false
          self.favorites = true
          }
        },
      ],
      underlay: '',
      tempSearch: '',
      newTag: '',
      tags: [],
    };
  },
  components: {
    draggable,
  },
  watch: {
    'storeState.activeQueue': {
        handler: function (val, oldVal) {
          console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
          // this.$route.params.id = val
          // this.$router.push({ name: 'Queues', params: { id: val }}).catch(err => console.error(err))
          this.blockCategories.find(q => q.id === Number(val)).f(this)
          this.$forceUpdate()
          // this.storeState.searchTerm = q
          // this.search({})
        }
    }
  },
  filters: {
    fromNowFilter: function (data) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${data.email}`]
      if (details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    saveSource() {
      this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
      const path = store.getPath('/soup_save_source')
      const d = this.newSource
      d.sessionId = this.storeState.sessionId
      var self = this
      self.savingSource = true
      axios.post(path, d)
        .then((res) => {
          console.log('got soup_save_source: ', res.data)
          self.storeState.block.source.uuid = res.data.block_uuid
          self.testRunSource(self)
        })
        .catch((error) => {
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    validateSource() {
      //all
      if (this.newSource.db_type === 'airtable') {
        this.storeState.block.cellType = 'airtableAsSql'
        
        if (!this.newSource.apiKey) {
          this.$refs.newSourceApiKey.focus();
          return false;
        }
        if (!this.newSource.name) {
          this.this.$refs.newSourceName.focus()
          return false;
        }
        return true;
      }
      if (this.newSource.db_type === 'bigquery') {
        // this.storeState.block.cellType = 'bigquery'
        if (!this.newSource.apiKey) {
          this.$refs.newSourceApiKey.focus();
          return false;
        }
        if (!this.newSource.name) {
          this.this.$refs.newSourceName.focus()
          return false;
        }
        return true;
      }
      if (!this.newSource.name) {
        this.$refs.newSourceName.focus()
        return false
      }
      if (!this.newSource.username) {
        this.$refs.newSourceUsername.focus()
        return false
      }
      //not snowflake
      if (this.newSource.db_type != 'snowflake' && (!this.newSource.port || isNaN(this.newSource.port))) {
        this.$refs.newSourcePort.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && !this.newSource.host) {
        this.$refs.newSourceHost.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && !this.newSource.database) {
        this.$refs.newDatabaseName.focus()
        return false
      }
      if (this.newSource.db_type != 'snowflake' && (this.newSource.host.startsWith('https:') || this.newSource.host.startsWith('http:'))) {
        this.$refs.newSourceHost.focus()
        this.connectError = 'Do not include HTTP / HTTPS in the host name'
        return false
      }
      if (this.newSource.db_type != 'snowflake' && (
            this.newSource.ssh) && this.newSource.sshPrivateKey && 
            this.newSource.sshPrivateKey.includes('OPENSSH')) {
        this.$refs.sshPrivateKey.focus()
        this.connectError = `You can't use an OPENSSH private key, use an RSA key instead`
        return false
      }
      //snowflake
      if (this.newSource.db_type === 'snowflake' && !this.newSource.accountName) {
        this.$refs.newSourceAccountName.focus()
        return false
      }
      if (this.newSource.db_type === 'snowflake' && !this.newSource.region) {
        this.$refs.newSourceRegion.focus()
        return false
      }
      if (this.newSource.db_type === 'snowflake' && !this.newSource.database) {
        this.$refs.newDatabaseName.focus()
        return false
      }
      return true
    },
    editSourcefields(self) {
      let valid = this.validateSource()
      if (!valid) return
      this.storeState.block = JSON.parse(JSON.stringify(this.storeState.blockTemplate))
      const path = store.getPath('/soup_edit_source')
      
      const d = this.newSource
      d.sessionId = this.storeState.sessionId
      var self = this
      self.savingSource = true
      axios.post(path, d)
        .then((res) => {
          if (res.data.ok){
            console.log('from inside if')
            self.savingSource=false
            self.storeState.snackbar = true;
            self.storeState.addingSource = false
            self.storeState.message = 'Source updated!';
            self.$parent.getSoupSources()
          }
          else{
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = res.data.error;
          }

          self.storeState.block.source.uuid = res.data.block_uuid
         // self.testRunSource(self)
        })
        .catch((error) => {
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    timeoutTest(self) {
      if (self.savingSource) {
        self.whitelistError = true
        self.savingSource = false
        self.storeState.snackbar = true;
        self.storeState.message = 'Connection took longer than 15 seconds, check your connection properties and try again';
      }
    },
    testRunSource(self) {
      let block = store.cleanUpBlock(self.storeState.block);
      let data = {
        sessionId: self.storeState.sessionId,
        block: block,
        test: true
      }
      setTimeout(() => {
        self.timeoutTest(self)
      }, 15000);
      axios.post(store.getPathRunner('/run_one'), data)
        .then((res) => {
          if (res.data.ok) {
            console.log('testRunSource: ', res.data)
            self.storeState.addingSource = false
            self.savingSource = false
            self.storeState.snackbar = true;
            self.storeState.message = 'Source added!';
            self.$parent.getSoupSources()
          } else {
            console.error('testRunSource error: ', res.data)
            self.savingSource = false
            self.storeState.snackbar = true
            let err = res.data.error.replace('<', '')
            self.storeState.message = err
            self.connectError = err
          }
        })
        .catch((error) => {
          console.error('runCode error', error)
          self.savingSource = false
          self.storeState.snackbar = true;
          self.storeState.message = error;
        })
    },
    cancelAddSource() {
      this.storeState.addingSource = false
      this.savingSource = false
    },
    backToBlocks() {
      this.$router.push({ name: 'Blocks'}).catch(err => console.error(err))
    },
    showSearch() {
      this.storeState.searching = true
      this.$router.push({ name: 'Search'}).catch(err => console.error(err))
      setTimeout(() => {
        this.$refs.searchText.focus()
      }, 0);
    },
    getUserPic(email) {
      let u = this.storeState.settings.team.members.find(u => u.email === email)
      if (u) return u.pic
      return ''
    },
    fromNowRunFormat: function (data) {
      if (!data) return 'Never run'
      return moment(data/1000).fromNow()
    },
    editSource(source) {
      this.storeState.addingSource = true
      if (source.port) {
        //
      } else if (source.host.includes(':')) {
        source.port = source.host.split(':')[1]
      } else {
        source.port = ''
      }
      this.newSource = source
      // newSource: {
      //   name: '',
      //   db_type: 'mysql',
      //   host: '',
      //   port: '',
      //   ssl: false,
      //   username: '',
      //   password: '',
      //   database: '',
      //   metadata: false,
      // },
    },
    deleteSource(source) {
      // Vue.delete(this.storeState.blocks, block.uuid)
      this.storeState.allSources = _.reject(this.storeState.allSources, function(el) { return el.name === source.name; });
      store.deleteSource(source)
    },
    favoriteSource(source) {
      source.favorite = !source.favorite
      this.$forceUpdate()
      store.favoriteSource(source)
    },
    runBlock(block) {
      this.$parent.openBlock(block.uuid)
    },
    getSourceName(row) {
      let s = this.storeState.allSources.find(s => s.block_uuid === row.source.uuid)
      if (s && s.name) return `${s.name}`
      return ''
    },
    hoverRow(row, index, hover) {
      if (hover) {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = index
      } else {
        this.storeState.searchIndex = -1
        this.blockHoverIndex = -1
      }
    },
    rowClick(e) {
      console.log('rowClick: ', e)
      var self = this
      if (e.currentTarget.dataset.uuid) {
        console.log('e.currentTarget.id: ', e.currentTarget.dataset.uuid)
        this.$parent.openBlock(e.currentTarget.dataset.uuid)
      }
    },
    getFromNow: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.reminder) {
        let m = moment(details.reminder)
        return m.fromNow()
      } else {
        return ''
      }
    },
    getTags: function (row) {
      let detail_type = 'users'
      let details = this.storeState.editableDetailsAll[`${detail_type}-${row.email}`]
      if (details && details.tags) {
        return details.tags
      } else {
        return ''
      }
    },
    portHint: function () {
      let hint = this.dbTypes.find(d => d.key === this.newSource.db_type).portHint
      return hint || ''
    },
    openSettings() {
      this.storeState.cmdkParentCmd = 'settings'
      this.$parent.openCmdK({cmdkParentCmd: 'settings', cmdkInput: ''})
    },
    newBlock() {
      let blockId = store.uuidv4()
      this.storeState.newBlocks.push(blockId)
      console.log('newBlocks: ', this.storeState.newBlocks)
      this.$router.push({ name: 'Run', params: {id:  blockId}}).catch(err => console.error(err))
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.storeState.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  computed: {
    uniqueSources: function () {
      let result = []
      let uniqueNickNames = []
      for (let i = 0; i < this.storeState.allSources.length; i++) {
        let source = this.storeState.allSources[i]
        if (!uniqueNickNames.includes(source.name)) {
          uniqueNickNames.push(source.name)
          if (this.searchTerm && this.searchTerm.length > 0) {
            let searchIn = JSON.stringify(source)
            if (searchIn.includes(this.searchTerm)) {
              result.push(source)
            }
          } else {
            uniqueNickNames.push(source.name)
            result.push(source)
          }
          
        }
      }
      return result
    },
  },
  created() {
    this.filterBlocks = debounce(this.filterBlocks, 200)
    // this.getFoodFacts();
    // this.renderUserEntries();
  },
};
</script>

<style>
.active {
  background-color: #eee;
  border-left-color: #333;
  border-left-style: solid;
  border-left-width: 3px;
}
.searchResultRows {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 40px;
  padding-right: 30px;
}

.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.search-input-container {
  padding-bottom: 20px;
  padding-left: 40px;
}
.row-sub-title {
  color: #ccc;
  padding-left: 10px;
}
.row-reminder {
  color: rgb(46, 170, 220);
  padding-left: 10px;
}
.save-search-q {
  float: right;
  margin-top: -35px;
  margin-right: 26px;
}
.block-search {
  float: right;
  margin-top: -35px;
  margin-right: 3px;
}
.search-container {
  padding-top: 60px;
}
.term-underlay {
  /* margin-left: 8px; */
  /* margin-top: 1px; */
  background: rgba(84, 172, 220, 0.2);
  box-shadow: 0 0 0 2px rgba(84, 172, 220, 0.2);
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-text {
  /* margin-left: 0px; */
  background: transparent;
  box-shadow: none;
  opacity: 0.5;
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.term-underlay-partial {
  /* margin-left: 0px; */
  background: rgba(249, 150, 255, 0.2);
  box-shadow: none;
}
.search-underlay {
  position: absolute;
  width: 100%;
}
#soupSearchContainer {
  display: -webkit-inline-box;
  position: absolute;
  width: 100%;
  margin-left: 20px;
}
.soup-queue-container {
  margin-left: 0px;
  margin-top: 15px;
  margin-bottom: 20px;
}
.row-title {
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-pic {
  display: inline;
}
.row-code {
  color: rgba(0, 0, 0, 0.5);
  /* display: inline; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-last-run {
  color: rgba(0, 0, 0, 0.5);
  float: right;
}
.row-host {
  color: rgba(0, 0, 0, 0.5);
  float: left;
}
.block-icons {
  float: right;
}
.blocks-icon {
}
.sw-button {
  height: 40px;
  display: inline-block;
  line-height: 40px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: "Rubik";
  border-radius: 4px;
  text-align: center;
  background: #19774d;
  border: solid 1px #19774d;
  color: white;
  font-size: 0.875rem;
  text-decoration: none;
  padding: 0 1.5rem;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  cursor: pointer;
}
.sw-button:hover {
  background-color: #50a779;
  border-color: #50a779;
}
.v-tab {
  min-width: 0px !important;
  padding-right: 46px !important;
  font-size: 20px !important;
  text-transform: none !important;
}
.left {
  float: left;
}
.nopad {
  padding-bottom: 0px !important;
  padding-top: 8px !important;
}
.favorite {
  padding-right: 10px !important;
  margin-top: 1px;
}
.conn-top-right {
  float: right;
  margin-top: -35px;
  margin-right: 4rem;
}
.conn-top-right2 {
  float: right;
  margin-top: -35px;
  margin-right: 1rem;
}
</style>
